/* eslint-disable @eslint-react/no-array-index-key */
import { useFormApi } from '@data-driven-forms/react-form-renderer';
import { ChildrenWidget } from 'lib-node-amb-renderer';

import { Td, Tr } from '~/common/components/Tables';

export class KYLTableRowClass extends ChildrenWidget {
  constructor(props) {
    super(props);
  }
}

type KYLTableRowProps = {
  fields?: any[];
  colSpan?: number;
  position?: number;
  sx?: any;
  headerCols?: number;
};

export default function KYLTableRow({
  fields,
  position,
  colSpan,
  headerCols,
  ...rest
}: Readonly<KYLTableRowProps>) {
  const { renderForm } = useFormApi();
  return (
    <Tr
      {...rest}
      sx={{
        background: position % 2 === 0 ? '#FAFAFA' : '',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      {fields?.map((field, index) => (
        <Td
          colSpan={colSpan ? colSpan[index] : headerCols[index].colSpan}
          key={index}
          sx={{
            borderBottom: '0 !important',
            borderLeft: '0 !important',
            borderRight: '1px solid #979797 !important',
            fontSize: '0.875rem',
            '& > div': {
              margin: '0 !important',
            },

            '&:first-of-type': {
              borderRadius: '0 0 0 4px',
              paddingLeft: '1.875rem !important',
            },

            '&:last-of-type': {
              borderRight: '0 !important',
              borderRadius: '0 0 4px 0',
            },
          }}
        >
          {field && renderForm([field])}
        </Td>
      ))}
    </Tr>
  );
}
